import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-weight: 700;
  background: linear-gradient(to right, var(--secondary_color), var(--black));
  border-radius: 0 0 0.8rem 0.8rem;
  padding: 0.4rem 4rem;

  .header-tags {
    display: flex;
    gap: 1rem;
    margin: 0.4rem 0;
    position: absolute;
    left: 15rem;

    li {
      width: 100%;
      background-color: var(--primary_color);
      border-radius: 0.2rem;
      padding: 0.4rem;

      a {
        display: flex;
      }
    }
  }

  .header-navigation-tree-content {
    position: relative;
  }

  .header-navigation-tree-content,
  .header-navigation-tree-info,
  .header-navigation-tree-info-group,
  .header-navigation-tree-info-download-app-info,
  .header-navigation-tree-info-download-app {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-weight: 700;
  }

  .header-navigation-tree-info {
    margin-left: auto;
    gap: 0.2rem;
    font-size: 1rem;
    color: var(--white);

    .header-navigation-tree-info-group {
      gap: 0.4rem;
      text-transform: none;
    }

    .header-navigation-tree-info-download-app-info {
      flex-direction: column;
      color: var(--black);
    }

    .header-navigation-tree-info-group {
      gap: 0.4rem;
      text-transform: none;
    }

    .header-navigation-tree-info-group + .header-navigation-tree-info-group {
      margin-left: 0.8rem;
    }

    .header-navigation-tree-info-group span,
    .brands-group-ultra span {
      border-radius: 0.2rem;
      padding: 0.2rem 0.4rem;
      background-color: var(--primary_color);
    }

    .header-navigation-tree-info-group span:hover,
    .brands-group-ultra span:hover {
      opacity: 0.8;
    }

    .brands-group-ultra {
      min-width: 11.375rem;
      user-select: none;
      display: flex;
      position: relative;
      cursor: pointer;
      padding: 1rem 0.8rem;
      border-radius: 0.8rem 0.8rem 0 0;
      text-transform: none;

      &.show {
        color: var(--primary_color);
        background-color: var(--white);
      }

      &.show span {
        font-weight: 700;
        background-color: var(--white) !important;
      }

      .all-brands-group-ultra {
        background-color: var(--white);
        width: 100%;
        padding: 0.8rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 3.4rem;
        left: 0;
        gap: 1.2rem;
        border-radius: 0 0 0.8rem 0.8rem;
        z-index: 2;

        img {
          width: min-content;
        }
      }
    }
  }
`;
